module["exports"] = ["Jr.", "Sr."];